import { Navigate } from 'react-router-dom';
import { FuseRouteConfigType } from '@fuse/utils/FuseUtils';
import authRoles from 'src/app/auth/authRoles';
import NotificationsAdminApp from './NotificationsAdminApp';

const NotificationsAdminConfig: FuseRouteConfigType = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: ['Godfather'], // Only godfather role can access
  routes: [
    {
      path: '/admin/notifications',
      element: <NotificationsAdminApp />,
    },
  ],
};

export default NotificationsAdminConfig;